document.addEventListener('DOMContentLoaded', () => {
          const WISHLIST_KEY = 'atelier_custom_wishlist';

          function getWishlist() {
                    try {
                              const data = localStorage.getItem(WISHLIST_KEY);
                              let list = data ? JSON.parse(data) : [];
                              if (!Array.isArray(list)) list = [];

                              // Strict Migration: ONLY keep valid objects with a handle
                              const validList = list.filter(item => item && typeof item === 'object' && typeof item.handle === 'string');
                              // If we filtered out garbage data from older versions, resave immediately
                              if (validList.length !== list.length) {
                                        saveWishlist(validList);
                                        return validList;
                              }
                              return list;
                    } catch (e) {
                              console.error('Error reading wishlist from localStorage:', e);
                              return [];
                    }
          }

          function saveWishlist(wishlist) {
                    try {
                              localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
                    } catch (e) {
                              console.error('Error writing wishlist to localStorage:', e);
                    }
          }

          function updateWishlistCounter() {
                    const wishlist = getWishlist();
                    const count = wishlist.length;
                    const headerIcon = document.getElementById('header-wishlist-icon');

                    if (headerIcon) {
                              const outline = headerIcon.querySelector('.icon-heart-outline');
                              const solid = headerIcon.querySelector('.icon-heart-solid');
                              if (count > 0) {
                                        if (outline) outline.style.display = 'none';
                                        if (solid) {
                                                  solid.style.display = 'block';
                                                  solid.classList.remove('hidden');
                                        }
                              } else {
                                        if (outline) outline.style.display = 'block';
                                        if (solid) {
                                                  solid.style.display = 'none';
                                                  solid.classList.add('hidden');
                                        }
                              }
                    }
          }

          function updateWishlistButtons() {
                    const wishlist = getWishlist();
                    const handles = wishlist.map(item => item.handle);
                    const buttons = document.querySelectorAll('.wishlist-btn');

                    buttons.forEach(btn => {
                              const handle = btn.getAttribute('data-product-handle');
                              if (handle && handles.includes(handle)) {
                                        btn.classList.add('is-active');
                              } else {
                                        btn.classList.remove('is-active');
                              }
                    });
          }

          /**
           * @param {Element} btn
           */
          function toggleWishlistStatus(btn) {
                    const handle = btn.getAttribute('data-product-handle');
                    if (!handle) return;

                    let wishlist = getWishlist();
                    const index = wishlist.findIndex(item => item.handle === handle);

                    if (index > -1) {
                              wishlist.splice(index, 1);
                    } else {
                              wishlist.push({
                                        handle: handle,
                                        variantId: btn.getAttribute('data-variant-id') || '',
                                        title: btn.getAttribute('data-product-title') || handle,
                                        url: btn.getAttribute('data-product-url') || ('/products/' + handle),
                                        image: btn.getAttribute('data-product-image') || '',
                                        price: btn.getAttribute('data-product-price') || '',
                                        compare_at_price: btn.getAttribute('data-product-compare-at-price') || null
                              });
                    }

                    saveWishlist(wishlist);
                    updateWishlistCounter();
                    updateWishlistButtons();

                    // Trigger custom event so page can re-render if we are on the wishlist page
                    document.dispatchEvent(new CustomEvent('wishlist:updated'));
          }

          document.body.addEventListener('click', (e) => {
                    const btn = e.target.closest('.wishlist-btn');
                    if (btn) {
                              e.preventDefault();
                              e.stopPropagation();
                              toggleWishlistStatus(btn);
                    }
          });

          // initial load
          window.updateWishlistButtons = updateWishlistButtons;
          updateWishlistCounter();
          updateWishlistButtons();
});
